
import { defineComponent, getCurrentInstance, computed } from "vue-demi";
import { API_TNotificationsShortListItem, TNotificationTag } from "@/models/notifications";
import { SMUser } from "@/store";

export default defineComponent({
  name: "NotificationsTasks",

  components: {
    NotificationsTaskTemplate: () =>
      import("@/modules/Notifications/NotificationsTasks/NotificationsTaskTemplate.vue"),
    Select: () => import("@/modules/Notifications/Select/Select.vue"),
    NotificationsEmpty: () => import("@/modules/Notifications/components/NotificationsEmpty.vue"),
  },

  props: {
    items: { type: Array as () => API_TNotificationsShortListItem[], default: () => [] },
    loading: { type: Boolean, default: false },
  },

  emits: ["filter-changed"],

  setup(_, { emit }) {
    interface Actions {
      updateValue: (v: TNotificationTag) => void;
    }

    const actions: Actions = {
      updateValue(v: TNotificationTag) {
        emit("filter-changed", v);
      },
    };

    function callAction(payload: { action: string; value: TNotificationTag }) {
      try {
        actions[payload.action](payload.value);
      } catch {
        console.log(`Action "${payload.action}" is not defined`);
      }
    }

    const menuOptions = [
      {
        label: "All",
        value: "all",
        action: "updateValue",
      },
      {
        label: "Overdue",
        value: "overdue",
        action: "updateValue",
      },
      {
        label: "Due soon",
        value: "due_soon",
        action: "updateValue",
      },
    ];

    function parseCategory(str: string): string {
      try {
        const obj = JSON.parse(str);
        const value = obj.compliance_category || "";

        if (!value) return "";

        return value.replace(/_/g, " ").replace(/^./, (char) => char.toUpperCase());
      } catch {
        return "";
      }
    }

    const router = getCurrentInstance()?.proxy?.$router;

    async function openTask(id: number) {
      try {
        await router.push(`${SMUser.basePath}/tasks/${id}`);
      } catch {
        return;
      }
    }

    const isComplianceBlocked = computed(() => SMUser.isComplianceBlocked);

    return {
      menuOptions,
      callAction,
      parseCategory,
      openTask,
      isComplianceBlocked,
    };
  },
});
